import { DataLimitProps } from './types';
import { Trans, type I18nLocale, t } from '@ardoq/i18n';

export const getWarningTitle = (
  { isEmpty = false, reducedDegrees = 0, isAboveLimit = false }: DataLimitProps,
  i18nLocale: I18nLocale
) => {
  if (reducedDegrees || isAboveLimit) {
    return t(
      i18nLocale,
      'dataLimit:warning.tooManyEntitiesTitle',
      'There are too many components and references to show. This visualization may run slowly.'
    );
  }
  if (isEmpty) {
    return t(
      i18nLocale,
      'dataLimit:warning.emptyContextTitle',
      'There are no components or references to show for the current context.'
    );
  }
  return null;
};

export const getWarningSubtitle = (
  { reducedDegrees = 0, isAboveLimit = false }: DataLimitProps,
  i18nLocale: I18nLocale
) => {
  if (reducedDegrees) {
    return (
      <>
        <p>
          <Trans
            i18nKey="dataLimit:warning.reducedDegrees"
            defaults="We reduced the traversed distance to <degrees>{{count}} degrees of separation</degrees> for your convenience."
            values={{ count: reducedDegrees }}
            components={{ degrees: <strong /> }}
          />
        </p>
        <p>
          {t(
            i18nLocale,
            'dataLimit:warning.narrowDownSelection',
            'You can narrow down your selection by choosing a component from the navigator on the left or by applying filters.'
          )}
        </p>
      </>
    );
  }
  if (isAboveLimit) {
    return t(
      i18nLocale,
      'dataLimit:warning.narrowDownSelectionShort',
      'Narrow down your selection by choosing a component from the navigator on the left, or by applying filters.'
    );
  }
  return null;
};
